import { WSAlert, WSList, WSText } from "@wingspanhq/fe-component-library";
import React from "react";

export const RefundExplainer: React.FC = () => (
  <WSAlert theme="info" icon="info-circle" title="What is a refund?">
    <WSList gap="S">
      <WSText.ParagraphSm>
        Mark an <strong>expense</strong> as a refund when a merchant returns a
        purchase — the refunded amount is subtracted from your expenses, so a
        $10 charge and a $10 refund net to $0.
      </WSText.ParagraphSm>
      <WSText.ParagraphSm>
        Mark an <strong>income</strong> transaction as a refund when you return
        money to a client — the amount is subtracted from your income.
      </WSText.ParagraphSm>
    </WSList>
  </WSAlert>
);
